import Config from '@/config/config'
import { ifAuthenticated } from '@/router/before'

export const authPages = [
  {
    path: Config.routing.authPage.path,
    name: 'AuthRoute',
    meta: {
      icon: ['fas', 'sign-in-alt'],
      isDisplayInSidebar: false,
      group: Config.systemTitle.fullName,
      displayName: Config.routing.authPage.name,
    },
    component: () =>
      import(/* webpackChunkName: "AuthRoute" */ '@/views/auth/AuthRoute.vue'),
  },
  {
    path: '/logout',
    name: 'Logout',
    meta: {
      icon: null,
      isDisplayInSidebar: false,
      group: 'Главная',
      displayName: '',
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "Logout" */ '@/views/Logout.vue'),
  },
  {
    path: '/registration',
    name: 'RegistrationRoute',
    meta: {
      sidebar: null,
      navbar: {
        group: Config.systemTitle.fullName,
        displayName: 'Регистрация',
      },
      breadcrumbs: null,
    },
    component: () =>
      import(
        /* webpackChunkName: "RegistrationRoute" */ '@/views/auth/RegistrationRoute.vue'
      ),
  },
  {
    path: '/login',
    name: 'LoginRoute',
    meta: {
      sidebar: null,
      navbar: {
        group: Config.systemTitle.fullName,
        displayName: 'Вход',
      },
      breadcrumbs: null,
    },
    component: () =>
      import(
        /* webpackChunkName: "LoginRoute" */ '@/views/auth/LoginRoute.vue'
      ),
  },
  {
    path: '/password-recovery',
    name: 'PasswordRecoveryRoute',
    meta: {
      sidebar: null,
      navbar: {
        group: Config.systemTitle.fullName,
        displayName: 'Восстановление пароля',
      },
      breadcrumbs: null,
    },
    component: () =>
      import(
        /* webpackChunkName: "PasswordRecoveryRoute" */ '@/views/auth/PasswordRecoveryRoute.vue'
      ),
  },
  {
    path: '/invite-link',
    name: 'InviteLinkRoute',
    meta: {
      sidebar: null,
      navbar: null,
      breadcrumbs: null,
    },
    component: () =>
      import(
        /* webpackChunkName: "InviteLinkRoute" */ '@/views/auth/InviteLinkRoute.vue'
      ),
  },
]
